namespace('arctic.views.individual');

compass.require('compass.hotel.StayRecapWidget');
compass.require('compass.hotel.PoliciesWidget');
compass.require('compass.hotel.LowInventoryWarningWidget');

compass.require('compass.demographic.IndividualFormsWidget');
compass.require('compass.demographic.DupeSelectWidget');

compass.requireLib('compass.util.tracking');

arctic.views.individual.personalInfo = function(viewport,options) {
	// starts measuring the time it takes for the view to load
	compass.startLoad('personalInfoView');

	var me = this;

	var _viewport = viewport;
	var d = jQuery.dom;
	var $j = jQuery;

	var _settings = options;
	var _stayRecapWidget, _individualFormsWidget, _lowInventoryWarningWidget;

	var _ids = {
		contact: compass.generateId(),
		payment: compass.generateId(),
		requests: compass.generateId(),
		shares: compass.generateId(),
		policies: compass.generateId()
	};

	var _render = function() {
		if (compass.isRedesignEnabled()) {
			// Redesign layout: two-column with cleaner structure
			_viewport.append(d.div({ className : 'personalInfo redesign' },
				d.div({ className: 'personalInfoHeader redesign' },
					d.h1({ className: 'pageTitle' }, 'Review and Reserve'),
					d.reader('Personal Information – complete form and submit to complete reservation')
				),
				d.div({ className: 'personalInfoContent redesign' },
					d.div({ className: 'lowInventoryWarningContainer redesign' }),
					d.div({ className: 'individualFormsContainer redesign' }),
					d.div({ className : 'stayRecapMain redesign' },
						d.h2({ className: 'reservationSummaryTitle' }, 'Reservation Summary'),
						d.reader(d.h2('Reservation Summary'))
					)
				),
				d.div({className : 'clear'})
			));
		} else {
			// Legacy layout
			_viewport.append(d.div({ className : 'personalInfo' },
				d.h2(
					d.reader('Personal Information – complete form and submit to complete reservation')
				),
				d.div({ className: 'lowInventoryWarningContainer' }),
				d.div({ className: 'individualFormsContainer' }),
				d.div({ className : 'stayRecapMain' }, d.reader(d.h2('Reservation Summary'))),
				d.div({className : 'clear'})
			));
		}
		compass.loading.stop();
	};

	var _showPoliciesPopup = function(viewdata) {
		jQuery.ajax({
			data: { blocked_room_id: viewdata.blockedRoomId },
			dataType:'json',
			traditional: true,
			url:'/policies', success : function(data) {
				var policiesDiv = d.div({className:'policiesContainer'});
				_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv, {
						WUID : 'policiesWidget_individualPersonalInfo',
						policies: data
					});

				_policiesDialog = d.dialog({
					classes: 'personalInfo policiesDialog',
					contents: policiesDiv,
					dialogId: _ids.policies,
					centerOnView: true
				});
			}
		});
	};

	var _dupeDialog = false;
	var _makeDupesDialog = function (dupeArray) {
		if (_dupeDialog) {
			return;
		}

		var label = {
			header: "Have we met?",
			description: "We found a record in our system that matches your name and email address.",
			loginDescription: "Enter the password associated with your reservation. Any shopping you've done so far will be lost."
		};

		var container = d.div({},
			d.h4({className : "dupeHeader"},
				d.reader('You may already exist in our system. Select a your record below or select “No” to continue booking'),
				label.header),
			d.div({className : "dupeDescription"}, label.description));
		var dupeWidget = new compass.demographic.DupeSelectWidget(container, {
			dupes: dupeArray
		});

		_dupeDialog = d.dialog({
			classes: 'personalInfo dupeDialog',
			disableClicksOutsideModal: true,
			contents: container
		});

		dupeWidget.bind('DupeSelectWidget.NoRecord', function () {
			_dupeDialog.close();
			_dupeDialog = false;
			_lastElementFocused.focus();

		});
		dupeWidget.bind('DupeSelectWidget.ExistingRecord', function (event, dupeInfo) {
			var emailAddress;

			var container = d.div({},
				d.div({ }, label.loginDescription),
				d.div({className : "onPeakId"}, _settings.meetingInfo.officeName + " ID: " + dupeInfo.email)
			);

			var loginWidget = new compass.show.LoginWidget(container, {
				branchInfo : {
					attendance_id : dupeInfo.attendance_id,
					route: dupeInfo.housing ? "" : "personalInfo"
				},
				meetingInfo : _settings.meetingInfo,
				onpeakID : dupeInfo.attendance_id
			});

			loginDialog = d.dialog({
				classes: 'personalInfo loginDialog',
				showParent: true,
				contents: container
			});
		});
		$('body').bind('LoginWidget.ForgotPasswordRequest', function (event, data) {
			var container = d.div({});
			var resetExternalPasswordWidget = new compass.account.ResetPasswordWidget(container, {onpeakID:data.onpeakID, meetingInfo: _settings.meetingInfo, callback: function(){resetDialog.close();}});

			resetDialog = d.dialog({
				classes: 'resetExternalPassword resetDialog',
				showParent: true,
				contents: container
			});
		});
	};

	var onFormSubmit = function(formData, onFinishSubmit) {
		if (_lowInventoryWarningWidget && _lowInventoryWarningWidget.isSoldOut()) {
			formData.soldOutAcknowledged = formData.policiesCheckbox;
		}

		jQuery.ajax({
			url : '/actPersonalInfo',
			data : JSON.stringify(formData),
			type : 'POST',
			contentType : 'application/json',
			success : function(data) {
				// put logic to move the page along if success is returned in data packet
				if ( data.success ) {
					if (data.soldOutAcknowledged === true) {
						// User acknowledged sold out status - info saved but no booking created
						compass.trackEvent('SoldOutAcknowledged');
						$j('body').trigger(CompassEvents.Login, data.loginInfo);
						$j('body').css({cursor : 'inherit'});
						jQuery('.forms').trigger(CompassEvents.Navigate, 'hotels');
					} else if (data.soldOut === false && data.foundExistingHousing === false){
						var estimatedTotal = _stayRecapWidget.getEstimatedTotalValue();
						jQuery.ajax({
						url : '/sendConfirmation',
							success : function(data) {
								compass.util.tracking.exactTargetConversion();
								compass.util.tracking.googleConversion({
									value: estimatedTotal,
									currency: _settings.meetingInfo.currencyCode
								});
							}
						});
						var estimatedTotal = _stayRecapWidget.getEstimatedTotalValue();
						var resTrackingData = _individualFormsWidget.getReservationData(); // Keen Tracking
						resTrackingData.iterations = _settings.iterations;
						compass.trackEvent('ReservationCreated', resTrackingData);
						compass.GA.trackEvent('Individual', 'ReservationCreated');
						compass.trackFbPixelEvent('Purchase', {value:estimatedTotal,currency:_settings.meetingInfo.currencyCode});
						jQuery('.forms').trigger(CompassEvents.Navigate, 'frontDesk');
						$j('body').trigger(CompassEvents.Login, data.loginInfo);
						$j('body').css({cursor : 'inherit'});
					} else if (data.foundExistingHousing === true) {
						compass.trackEvent('RaceConditionAlert');
						_existingHousingAlert = d.alert("You already have a reservation. You will now be directed to your reservation details.");
						jQuery('.alertCloseButton').click(function(){
							jQuery('.forms').trigger(CompassEvents.Navigate, 'frontDesk');
						});
					} else {
						compass.trackEvent('RaceConditionAlert');
						_soldOutAlert = d.alert("Another user booked the last available rooms while you were entering your details. We're sorry! Unfortunately, this means you'll need to restart your search (but we've saved your info so you won't have to key it in again).");
						jQuery('.alertCloseButton').click(function(){
							jQuery('.forms').trigger(CompassEvents.Navigate, 'hotels');
						});
					}

				} else {
					if (data.policiesCheckboxChecked === false) {
						if (_lowInventoryWarningWidget && _lowInventoryWarningWidget.isSoldOut()) {
							d.alert("Please confirm you understand the room is no longer available before saving your information.");
						} else {
							d.alert("Please agree to the hotel policies before continuing.");
						}
					} else {
				 		alert ('Problem creating record.');
					}
				}
				onFinishSubmit();
			}
		});
	};

	var _setupWidgets = function(viewdata) {
		// Setup low inventory warning widget
		_lowInventoryWarningWidget = new compass.hotel.LowInventoryWarningWidget(_viewport.find('.lowInventoryWarningContainer'), {
			WUID: 'lowInventoryWarningWidget_personalInfo',
			inventoryAvailability: viewdata.inventoryAvailability,
			meetingInfo: _settings.meetingInfo
		});

		_lowInventoryWarningWidget.bind('LowInventoryWarningWidget.returnToHotelList', function() {
			jQuery('.forms').trigger(CompassEvents.Navigate, 'hotels');
		});

		var recaps = _.filter(_.pluck(viewdata.reservations,'stayRecap'), function(e,i){
																return e.depositWillBeCharged;
							   });

		var minChargingDate = _.min(recaps,function(e){ return Number(e.depositWillBeChargedAt.split('-').join(''));}).depositWillBeChargedAt;

		var	_chargingInfo = {
			hasCharging : _.some(viewdata.reservations, function(r){return (r.stayRecap.depositWillBeCharged);}),
			chargingToday : _.some(viewdata.reservations, function(r){
																		return (r.stayRecap.depositWillBeCharged && r.stayRecap.depositWillBeChargedTodayOrEarlier);
																	}),
			chargingFirstDate : minChargingDate && minChargingDate.length > 0 ? compass.util.parse.ISODateParser(minChargingDate) : ''
		};

		_individualFormsWidget = new compass.demographic.IndividualFormsWidget(_viewport.find('.individualFormsContainer'), {
			WUID : 'individualFormsWidget',
			meetingInfo : _settings.meetingInfo,
			blockedRoomId : viewdata.blockedRoomId,
			commonRequests : viewdata.commonRequests,
			countriesAndStates : viewdata.countriesAndStates,
			extraRequiredFields : viewdata.extraRequiredFields,
			individualInfo : viewdata.individualInfo,
			paymentOptions : viewdata.paymentOptions,
			reservations : viewdata.reservations,
			validIndividualHousing : viewdata.validIndividualHousing,
			onFormSubmit : onFormSubmit,
			chargingInfo : _chargingInfo,
			ids : _ids,
			editablePrefill: _settings.regData
		});

		if (_lowInventoryWarningWidget.isSoldOut()) {
			compass.GA.trackEvent('LowInventory', 'IndividualSoldOutWarningShown');
			_viewport.find('.policiesTextDiv')
				.text('I understand this room is no longer available and want to save my information without booking.');
			_viewport.find('.policiesLink, .termsOfServiceText, .termsOfServiceLink').hide();
			_viewport.find('.policiesAgreeDiv').addClass('soldOutMode');
			_viewport.find('.finishButton').text('Save Information');
			_viewport.find('.roomRequestsHeader, .roomRequestsMain').hide();
			_viewport.find('.roomSharesHeader, .roomSharesMain, .frequentGuestNumberHolder').hide();
			_viewport.find('.stayRecapMain').hide();
		} else if (_lowInventoryWarningWidget.isDisplayingWarning()) {
			compass.GA.trackEvent('LowInventory', 'IndividualLowInventoryWarningShown');
		}

		_viewport.find('.returnToHotelListLink').activate(function() {
			jQuery('.forms').trigger(CompassEvents.Navigate, 'hotels');
		});

		_individualFormsWidget.find('.PersonalInfoWidget').bind('PersonalInfoWidget.DupeCheckReady', function (event, values) {

			jQuery.ajax({
				url: '/dupeCheck',
				type : 'POST',
				data: values,
				success: function (data) {
					if (data.dupes && data.dupes.length) {
						_lastElementFocused = $j(document.body).find(':focus');
						_lastElementFocused.blur();
						_makeDupesDialog(data.dupes);
					}
				}
			});
		});
		
		_stayRecapWidget = new compass.hotel.StayRecapWidget(_viewport.find('.stayRecapMain'), {
			WUID : 'stayRecapWidget_individualPersonalInfo',
			recapArray : viewdata.reservations,
			meetingInfo: _settings.meetingInfo,
			chargingInfo : viewdata.chargingInfo
		});

		_stayRecapWidget.bind('StayRecapWidget.showPolicies', function () {
			compass.GA.trackEvent('Hotel Policies', 'View Policies', 'Personal Info - Receipt');
			_showPoliciesPopup(viewdata);
		});


		_viewport.find(".policiesLink").activate(function(){
			compass.GA.trackEvent('Hotel Policies', 'View Policies', 'Personal Info - Agree Link');
			_showPoliciesPopup(viewdata);
		});

		_viewport.find(".stayRecapMain").append(d.div({className : 'stayRecapShadow'}));
	    
		_viewport.find('.policiesCheckbox').change(function() {
			if ($(this).is(':checked')) {
				$('.alertCloseButton').activate();
			}
		});
	};

	var _setupControls = function(viewData) { };

	this.run = function(renderComplete) {
		compass.loading.start();
		_settings.meeting_code = compass.matchDict.meetingCode;
		jQuery.ajax({
			url : '/personalInfo',
			success : function(data) {
				compass.loading.stop();
				if(data.noReservations){
					_viewport.trigger(CompassEvents.Navigate, 'hotels');
					return;
				}
				if(data.validIndividualHousing) {
					_viewport.trigger(CompassEvents.Navigate, 'frontDesk');
					return;
				}

				_settings.iterations = data.iterations || 1;
				_settings.countriesAndStates = data.countriesAndStates;
				_render();
				// move this into a renderer for testing.
				_setupWidgets(data);
				// draws the widgets and passes any rendering data into them.
	 			_setupControls();
				// sets up controls on the widgets. setups controls on the view itself.

				// trigger the event to let godview know that a view has loaded and return a string that can be prepended to the header widget
				// for better screen reading of the page
				_viewport.trigger(CompassEvents.ViewLoaded, 'Personal information ');

				// stops measuring the time it takes the view to load
				compass.stopLoad('personalInfoView');
				renderComplete();
			}
		});
	};
};

